export const KAM_SOURCE = 'kam';
